import api from '@/api';

import {
  DashboardData,
  DashboardQuick,
  DashboardQuickParams,
} from './Dashboard.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/Dashboard`;

export async function getDashboard(params: DashboardQuickParams) {
  const result = (await api.get(CONTROLLER_URL, params)) as unknown;

  return result as DashboardData;
}

export async function getDashboardQuick(params: DashboardQuickParams) {
  const result = (await api.get(`${CONTROLLER_URL}/quick`, params)) as unknown;

  return result as DashboardQuick;
}
